module.exports = __webpack_public_path__ + "assets/img/7.56a1a8c3.png";